var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "store-selector" }, [
    _c(
      "label",
      { staticClass: "field-label", attrs: { for: "store-select" } },
      [_vm._v(_vm._s(_vm.$t("store")))]
    ),
    _vm._v(" "),
    _c("div", { staticClass: "select-wrap" }, [
      _c(
        "select",
        {
          key: _vm.selectKey,
          staticClass: "field-input",
          attrs: { id: "store-select" },
          domProps: { value: _vm.selectedValue },
          on: { change: _vm.onSelectChange }
        },
        [
          _c("option", { attrs: { value: "", disabled: "" } }, [
            _vm._v(_vm._s(_vm.$t("storePlaceholder")))
          ]),
          _vm._v(" "),
          _vm._l(_vm.stores, function(s) {
            return _c(
              "option",
              { key: s.id, domProps: { value: String(s.id) } },
              [_vm._v(_vm._s(s.name))]
            )
          })
        ],
        2
      ),
      _vm._v(" "),
      _c("span", { staticClass: "select-arrow" }, [_vm._v("▾")])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6a57f3e0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6a57f3e0","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/StoreSelector.vue
// module id = 402
// module chunks = 0